module.exports = __webpack_public_path__ + "img/logo.a9b60ce6.png";